import React from "react"

import { COLOR } from "../../modules/constants"
import numerableLogo from "../../assets/images/numerable-2022-logo-white-on-transparent-RGB.png"

// Shown (instead of the whole app) for any URL with ?source=350club while CONSTANTS.THE350CLUB_ENABLED is false.
// NB: uses COLOR.BRAND.NUMERABLE, not COLOR.BRAND.STD, as the latter is set to the 350 Club colour for these URLs
const The350ClubClosed = () => (
  <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", fontFamily: "Roboto, Helvetica, Arial, sans-serif" }}>
    <div style={{ background: COLOR.BRAND.NUMERABLE, padding: "12px 16px" }}>
      <a href="https://www.numerable.io/">
        <img src={numerableLogo} alt="Numerable logo" style={{ height: 40 }} />
      </a>
    </div>
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 16, textAlign: "center" }}>
      <p style={{ fontSize: 30, maxWidth: 900 }}>
        The Numerable board intelligence platform is no longer accessible through The 350 Club
      </p>
      <p style={{ fontSize: 25, maxWidth: 900 }}>
        <a href="https://www.numerable.io/contact/" target="_blank" rel="noopener noreferrer" style={{ color: COLOR.BRAND.NUMERABLE }}>Contact Numerable</a> to start a trial, book a demo or subscribe
      </p>
    </div>
  </div>
)

export default The350ClubClosed
